"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    networkFirstFetch: ()=>networkFirstFetch
});
const external_helpers_js_namespaceObject = require("./helpers.js");
const external_util_js_namespaceObject = require("./util.js");
const networkFirstFetch = async (param)=>{
    let { request, cacheName, timeout = 8000, attachFetchStrategyToResponseHeader } = param;
    let response;
    const cacheService = new external_util_js_namespaceObject.CacheService(cacheName);
    try {
        const controller = new AbortController();
        const timeoutId = setTimeout(()=>{
            controller.abort();
        }, timeout);
        response = await fetch(request, {
            signal: controller.signal
        }).finally(()=>clearTimeout(timeoutId));
        if (response.status >= 400) throw new Error('status code error');
        {
            const clonedResponse = response.clone();
            const finalResponse = attachFetchStrategyToResponseHeader ? (0, external_helpers_js_namespaceObject.cloneResponseWithSourceHeader)(clonedResponse) : clonedResponse;
            cacheService.put(request, finalResponse);
        }
    } catch (error) {
        console.error(error);
        response = await cacheService.match(request);
    }
    if (!response) throw new Error(`NetworkFirstFetch ${(0, external_util_js_namespaceObject.getHref)(request)} failed`);
    return response;
};
exports.networkFirstFetch = __webpack_exports__.networkFirstFetch;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "networkFirstFetch"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
